import { memo } from 'react';

import { Images } from 'assets/images';

import { Modal } from '..';
import { IProps } from './name-plate-modal.type';
const ModalNamePlate = ({
	unitName,
	applicantName,
	applicantNationality,
	namePlateContent,
	franchiseName,
	...rest
}: IProps) => {
	return (
		<Modal
			title="명찰 미리보기"
			width={703}
			className="modal-preview"
			{...rest}
		>
			<div className="flex justify-center gap-[23px] items-center py-5">
				<div className="flex flex-col items-center">
					<p className="text-[14px] font-medium leading-[26px] text-font6 mb-[10px]">
						명찰 앞면 예시
					</p>
					<div className="h-[480px] text-center border flex flex-col items-center bg-[url('@/assets/images/icon_front_bg_name_plate.svg')] bg-no-repeat bg-bottom relative">
						<div className="h-2 bg-blue2 w-[300px]" />
						<p className="absolute top-4 left-2 text-font1 text-[11px]">
							No: ______________________
						</p>
						<img src={Images.iconNamePlate} className="mt-10 mb-4" alt="" />
						<p className="text-base font-medium text-dolphin">
							{unitName ? unitName : '{사업체}'}
						</p>
						<div className="w-[300px] shadow-avatar text-center">
							<p className="text-[14px] text-font9 leading-4 pb-[27px]">
								계절근로자 프로그램
							</p>
							<div className="flex justify-center relative">
								<img
									src={Images.avatarDefaultNamePlate}
									alt=""
									className="w-[152px] h-[192px] border-2 border-blue2"
								/>
							</div>
							<p className="text-[14px] mt-7 text-white opacity-70 leading-4 mb-1">
								{applicantNationality ? applicantNationality : '베트남'}
							</p>
							<p className="text-xl text-5 font-semibold text-white leading-6">
								{applicantName ? applicantName : '김근로'}
							</p>
							<p className="text-base text-5 font-semibold text-white leading-6 mt-4">
								{franchiseName ? franchiseName : '조이네 사과밭'}
							</p>
						</div>
					</div>
				</div>

				<div className="flex flex-col items-center">
					<p className="text-[14px] font-medium leading-[26px] text-font6 mb-[10px]">
						명찰 뒷면 예시
					</p>
					<div
						className={`h-[480px] text-center border flex flex-col items-center bg-[url('@/assets/images/icon_back_bg_name_plate.svg')] bg-no-repeat bg-bottom`}
					>
						<div className="h-2 bg-blue2 w-[300px]" />
						<img
							src={Images.iconNamePlate}
							className="mt-10 w-[23px] h-[21px]"
							alt=""
						/>
						<div className="h-[290px] w-[300px] shadow-avatar text-center pt-7 px-5 overflow-auto">
							<p className="text-[11px] leading-4 text-center text-font5 whitespace-pre-line">
								{namePlateContent}
							</p>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default memo(ModalNamePlate);
